import { CallEvent } from '@modules/SoftPhoneModule/types';
import TasksModule from '@modules/TasksModule';
import { AcceptedOnDevice, TaskState } from '@modules/TasksModule/types';
import { InboxContext } from '../types';
import { setOutboundCallToAccepted } from '../callHandlers/outboundCalls';
import { setCallToAccepted } from '../callHandlers/callStateHandler';
import InboxModule from '..';
import FeatureFlagModule, { FeatureFlagKeys } from '@modules/FeatureFlagModule';

function handleCallAnswered(context: InboxContext, event: CallEvent) {
  const taskId = event.pcsConversationSid || event.callId;

  const task = TasksModule.getTask(taskId);

  context.logger.info('handleCallAnswered', {
    taskId,
    task,
    event,
    taskIsTransfer: task?.isTransfer,
    taskIsOutbound: task?.isOutbound,
  });

  if (!task || task.state !== TaskState.Offered) {
    return;
  }

  // if this is an outbound or internal call, then we should mark
  // the task as accepted
  if (task.isOutbound) {
    setOutboundCallToAccepted(context, taskId);
  } else if (
    InboxModule.isDid(task) ||
    task.isTransfer ||
    // When RTCS is down, session.delivered never fires so queue calls must be
    // accepted here directly instead of waiting for the RTCS event.
    // task.queueId is only set by resolveQueueFromPcs in the RTCS-down path,
    // so it guards against the timing race where RTCS is UP but
    // handlePcsConversationFetched has not yet run (sessionId not yet set).
    (FeatureFlagModule.isEnabled(
      FeatureFlagKeys.featureRtcsDegradedQueueDetection,
    ) &&
      !InboxModule.hasSession(task) &&
      !!task.queueId)
  ) {
    // only set the call to accepted if it is a DID call, transfer, or RTCS-degraded queue call.
    // Queue calls with RTCS up should wait for session.delivered events.
    setCallToAccepted(
      context,
      taskId,
      event.remoteCallId,
      AcceptedOnDevice.ThisDevice,
    );
  }
}

export default handleCallAnswered;
